export const GENERIC_ICONS = {
  accessibility: true,
  error_outline: true,
  // Material Icons do diário (MUI v4) não tem esse glifo — some o ícone
  psychology: true,
  "": true
};

const ICON_HINTS = [
  ["SAÚDE MENTAL", "mood"],
  ["SAUDE MENTAL", "mood"],
  ["FALTA DE MATERIAL", "brush"],
  ["AUSÊNCIA DE TAREFA", "assignment"],
  ["AUSENCIA DE TAREFA", "assignment"],
  ["ATRASO", "access_time"],
  ["FALTA", "event_busy"],
  ["COMUNICAÇÃO", "mail"],
  ["COMUNICACAO", "mail"],
  ["ATITUDE", "sentiment_very_dissatisfied"],
  ["EXCLUÍD", "close"],
  ["EXCLUID", "close"],
  ["INDICADOR POSITIVO", "favorite"],
  ["DESTAQUE", "emoji_events"],
  ["COLABORAÇÃO", "group"],
  ["COLABORACAO", "group"],
  ["BOA CONDUTA", "thumb_up"],
  ["AJUDA", "volunteer_activism"],
  ["COORDENA", "supervisor_account"],
  ["ENCAMINHAMENTO", "assignment_ind"],
  ["CONVERSA COM RESPONS", "forum"],
  ["ACOMPANHAMENTO", "trending_up"],
  ["ORIENTAÇÃO", "record_voice_over"],
  ["ORIENTACAO", "record_voice_over"],
  ["REUNIÃO", "groups"],
  ["REUNIAO", "groups"],
  ["ADVERTÊNCIA", "report"],
  ["ADVERTENCIA", "report"],
  ["REGISTRO POSITIVO", "emoji_events"],
  ["RECONHECIMENTO", "emoji_events"],
  ["PARTICIPAÇÃO", "record_voice_over"],
  ["PARTICIPACAO", "record_voice_over"]
];

const COLOR_HINTS = [
  ["SAÚDE MENTAL", "#7B1FA2"],
  ["SAUDE MENTAL", "#7B1FA2"],
  ["EXCLUÍD", "#C62828"],
  ["EXCLUID", "#C62828"],
  ["FALTA DE MATERIAL", "#EF6C00"],
  ["AUSÊNCIA DE TAREFA", "#5C6BC0"],
  ["AUSENCIA DE TAREFA", "#5C6BC0"],
  ["ATRASO", "#F9A825"],
  ["FALTA", "#E53935"],
  ["COMUNICAÇÃO", "#0288D1"],
  ["COMUNICACAO", "#0288D1"],
  ["ATITUDE", "#E64A19"],
  ["INDICADOR POSITIVO", "#C2185B"],
  ["DESTAQUE", "#2E7D32"],
  ["BOA CONDUTA", "#43A047"],
  ["COLABORA", "#1565C0"],
  ["PARTICIPA", "#00838F"],
  ["AJUDA", "#00897B"],
  ["COORDENA", "#6A1B9A"],
  ["ENCAMINHAMENTO", "#6A1B9A"],
  ["CONVERSA COM RESPONS", "#7B1FA2"],
  ["ACOMPANHAMENTO", "#5E35B1"],
  ["ORIENTAÇÃO", "#8E24AA"],
  ["ORIENTACAO", "#8E24AA"],
  ["REUNIÃO", "#6A1B9A"],
  ["REUNIAO", "#6A1B9A"],
  ["ADVERTÊNCIA", "#D32F2F"],
  ["ADVERTENCIA", "#D32F2F"],
  ["REGISTRO POSITIVO", "#2E7D32"],
  ["RECONHECIMENTO", "#6A1B9A"]
];

const GROUP_COLORS = {
  "3": "#0288D1",
  "4": "#546E7A",
  "5": "#E64A19",
  "6": "#C62828",
  "7": "#2E7D32",
  "8": "#6A1B9A"
};

export function occurrenceLabel(occurrence) {
  return String(
    (occurrence &&
      (occurrence.name || occurrence.title || occurrence.reason)) ||
      ""
  );
}

function hintFromOccurrence(occurrence) {
  return occurrenceLabel(occurrence).toUpperCase();
}

function colorFromHints(occurrence) {
  const hint = hintFromOccurrence(occurrence);
  for (let i = 0; i < COLOR_HINTS.length; i += 1) {
    if (hint.indexOf(COLOR_HINTS[i][0]) >= 0) {
      return COLOR_HINTS[i][1];
    }
  }
  return "";
}

export function resolveOccurrenceIcon(occurrence) {
  const current = String((occurrence && occurrence.icon) || "").trim();
  if (current && !GENERIC_ICONS[current]) {
    return current;
  }
  const hint = hintFromOccurrence(occurrence);
  for (let i = 0; i < ICON_HINTS.length; i += 1) {
    if (hint.indexOf(ICON_HINTS[i][0]) >= 0) {
      return ICON_HINTS[i][1];
    }
  }
  if (occurrence && Number(occurrence.nivel) === 3) {
    return "supervisor_account";
  }
  if (occurrence && Number(occurrence.nivel) === 2) {
    return "assignment_ind";
  }
  return current || "event_note";
}

export function resolveOccurrenceColor(occurrence, primaryColor) {
  if (occurrence && occurrence.alert) {
    return "#d32f2f";
  }
  const catalogColor = String((occurrence && occurrence.color) || "");
  if (/^#[0-9A-Fa-f]{6}$/.test(catalogColor)) {
    return catalogColor;
  }
  const fromName = colorFromHints(occurrence);
  if (fromName) {
    return fromName;
  }
  const groupKey =
    occurrence && occurrence.idGroup != null ? String(occurrence.idGroup) : "";
  if (groupKey && GROUP_COLORS[groupKey]) {
    return GROUP_COLORS[groupKey];
  }
  const nivel = Number(occurrence && occurrence.nivel);
  if (nivel === 3) {
    return "#6A1B9A";
  }
  if (nivel === 2) {
    return "#0277BD";
  }
  return primaryColor || "#546E7A";
}
